import { styled } from '@mui/material/styles'

export const TextRegular = styled('span')(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  color: theme.palette.text.primary
}))

export const TextMedium = styled('span')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '14px',
  color: theme.palette.text.primary
}))

export const TextSemiBold = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '14px',
  color: theme.palette.text.primary
}))

export const TextBold = styled('span')(({ theme }) => ({
  fontWeight: 700,
  fontSize: '14px',
  color: theme.palette.text.primary
}))

export const TextHover = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  transition: 'color 0.2s ease',
  '&:hover': {
    color: theme.palette.primary.main
  }
}))
